import { motion } from 'motion/react';
import { services } from '@/data/services';
import { ServiceCard } from '@/components/ui/ServiceCard';
import { SectionHeading } from '@/components/ui/SectionHeading';

const container = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const child = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export function ServicesGrid() {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] flex flex-col gap-14">
        <SectionHeading
          eyebrow="What we do"
          title={<>Three services. One standard.</>}
          description="We ship logos, websites, and production-grade code. Pick one or combine all three - the quality does not move."
        />
        <motion.div
          className="grid gap-6 md:grid-cols-3"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {services.map((s) => (
            <motion.div key={s.slug} variants={child}>
              <ServiceCard
                title={s.title}
                tagline={s.tagline}
                href={`/services/${s.slug}`}
                illustration={s.illustration}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
